'use client';

import { ChartBarIcon, ArrowTrendingUpIcon, EyeIcon, HeartIcon } from '@heroicons/react/24/outline';

export default function PerformancePlaceholder() {
    return (
        <div className="bg-white shadow rounded-lg p-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                <span className="text-2xl mr-2">📈</span>
                Performance Analytics
            </h2>

            <div className="flex items-center justify-center h-64 bg-gradient-to-br from-blue-50 to-purple-50 rounded-lg border-2 border-dashed border-gray-300">
                <div className="text-center px-8">
                    <div className="flex justify-center space-x-3 mb-4">
                        <ChartBarIcon className="h-10 w-10 text-gray-400" />
                        <ArrowTrendingUpIcon className="h-10 w-10 text-gray-400" />
                        <EyeIcon className="h-10 w-10 text-gray-400" />
                        <HeartIcon className="h-10 w-10 text-gray-400" />
                    </div>

                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                        Coming Soon
                    </h3>
                    <p className="text-sm text-gray-600 mb-4 max-w-md">
                        Track your content performance with insights on page views, engagement metrics, and top-performing articles.
                    </p>

                    <div className="inline-flex items-center px-4 py-2 bg-gray-100 rounded-lg text-sm text-gray-700">
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Analytics integration in progress
                    </div>
                </div>
            </div>

            {/* Preview of future metrics */}
            <div className="mt-4 grid grid-cols-3 gap-3">
                <div className="bg-gray-50 p-3 rounded-lg text-center opacity-50">
                    <p className="text-xs text-gray-500 mb-1">Page Views</p>
                    <p className="text-lg font-semibold text-gray-400">---</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg text-center opacity-50">
                    <p className="text-xs text-gray-500 mb-1">Engagement Rate</p>
                    <p className="text-lg font-semibold text-gray-400">---%</p>
                </div>
                <div className="bg-gray-50 p-3 rounded-lg text-center opacity-50">
                    <p className="text-xs text-gray-500 mb-1">Top Article</p>
                    <p className="text-lg font-semibold text-gray-400">---</p>
                </div>
            </div>
        </div>
    );
}
